import { Autocomplete, CircularProgress, Grid, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { TFilterFieldsLocal, ToolbarFieldConfig } from "../ToolbarSinisterGeneric";

type Props = {
	field: ToolbarFieldConfig;
	filters: TFilterFieldsLocal;
	setFilter: (key: string, value: any) => void;
};

export const renderAutocompleteField = ({ field, filters, setFilter }: Props) => {
	const currentId = filters[field.key] ?? "";
	const [selectedOption, setSelectedOption] = useState<any>(null);

	// Atualiza o selectedOption sempre que o id ou as opções mudarem
	useEffect(() => {
		if (!field.options || !currentId) return;

		const matched = field.options.find((opt) => String(opt.id) === String(currentId));
		if (matched) setSelectedOption(matched);
	}, [currentId, field.options]);

	return (
		<Grid item key={field.key}>
			<Autocomplete
				size="small"
				options={field.options || []}
				value={selectedOption}
				isOptionEqualToValue={(opt, val) => String(opt.id) === String(val.id)}
				getOptionLabel={(option) => {
					if (typeof option === "string") return option;
					if (!option || typeof option !== "object") return "";
					return option.label ?? "";
				}}
				onInputChange={(_, inputValue) => {
					field.extraProps?.onInputChange?.(inputValue);
				}}
				onChange={(_, selected) => {
					setSelectedOption(selected);
					const newId = selected?.id ?? "";
					setFilter(field.key, newId);
					field.onChange?.(newId, filters, setFilter);
				}}
				loading={field.extraProps?.loading}
				renderInput={(params) => (
					<TextField
						{...params}
						label={field.label}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{field.extraProps?.loading && <CircularProgress size={20} />}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
				{...field.extraProps}
			/>
		</Grid>
	);
};
